import { render } from "./RouteNew.vue?vue&type=template&id=2d325d59&scoped=true&ts=true"
import script from "./RouteNew.vue?vue&type=script&lang=ts"
export * from "./RouteNew.vue?vue&type=script&lang=ts"

import "./RouteNew.vue?vue&type=style&index=0&id=2d325d59&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d325d59"]])

export default __exports__